import type { IsolatedKey } from 'Addons/fitmentSearch/isolatedKeys';

const isolatedKey: IsolatedKey = null;

export default isolatedKey;
